<template>
    <div class="immo-home-page">
        <div class="home-title-wrapper">
            <div class="home-title-container">
                <h1 v-html="focus.cartouche ? focus.cartouche.titre : '' "></h1>
                <p v-html="focus.cartouche ? focus.cartouche.titre : '' "></p>
                <ad-searchbar class="ad-search-bar" :full-size="false" @submit="onAdSearchSubmit"></ad-searchbar>
            </div>
            <img src="../../assets/images/immobilier/Giordano Immobilier_Accueil en haut.jpg" />
        </div>
        <div class="last-ad">
            <h3>Nos dernières annonces</h3>
            <div class="last-ad-container">
                <ad-preview-card v-for="ad, i in ads" :key="i" :ad="ad"></ad-preview-card>
            </div>
            <router-link :to="{ name: 'AdList' }">
                <button class="cg-btn cg-btn-primary">Voir toutes nos annonces</button>
            </router-link>
        </div>
        <div class="business-description-wrapper">
            <div class="business-description">
                <h3 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h3>
                <div class="flex">
                    <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
                    <img alt="Giordano Family"
                        src="../../assets/images/immobilier/immo-acceuil-savoir-faire.png">
                </div>
            </div>
        </div>
        <site-link siteName="Immobilier"></site-link>
    </div>
</template>

<script>
import DataApi from 'fm-data-api'
import AdSearchbar from './AdSearchbar.vue'
import AdPreviewCard from './AdPreviewCard.vue'
import SiteLink from '../Components/SiteLink.vue'
import { getFocus } from '../../mixins/getFocus'

export default {
    name: 'ImmoHome',
    components: {
        AdSearchbar,
        AdPreviewCard,
        SiteLink
    },
    mixins: [getFocus],
    data() {
        return {
            ads: {},
            focus: {}
        }
    },
    methods: {
        async getLastAds() {
            const options = {
                apiUrl: this.$apiUrl,
                databaseName: this.$databaseName,
                token: await this.$getMainToken()
            }
            this.dataApi = new DataApi(options)
            const sort = [{
                fieldName: 'd_dateAnnonce',
                sortOrder: 'descend'
            }]
            this.dataApi.getRecords('W_Annonce', sort, '', '3')
                .then((ads) => {
                    console.log('then')
                    const adsToInsert = {}
                    for (let ad of ads) {
                        ad.fieldData.recordId = ad.recordId
                        adsToInsert[ad.recordId] = ad.fieldData
                    }
                    this.ads = adsToInsert
                })
                .catch(err => {
                    console.log('catched')
                    console.log(err)
                })
        },
        onAdSearchSubmit(adSearchModel) {
            this.$router.push({ name: 'AdList', params: { adSearchModel: adSearchModel } })
        }
    },
    async beforeMount() {
        this.getLastAds()
        await this.getFocus('ti', 'Accueil')
        .then(res => {
            this.focus = res
        })
    }
}
</script>

<style lang="scss">
.immo-home-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
        font-size: 1.6rem;
        font-weight: normal;
        margin-bottom: 32px;
    }

    .home-title-wrapper {
        position: relative;
    }

    .ad-search-bar {
        position: absolute;
        top: 55%;

        .el-input__inner::placeholder {
            color: black;
        }
    }

    .phone {
        margin-top: 100px !important;
    }

    .last-ad {
        max-width: var(--max-width);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 64px 0;

        h3 {
            width: 100%;
            text-align: left;
        }


        .last-ad-container {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;

        }
    }


    .business-description-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
    }

    .business-description {
        max-width: var(--max-width);
        padding: 64px 0;

        p {
            text-align: start;
        }

        .flex {
            display: flex;
            justify-content: space-between;
        }

        img {
            max-width: 500px;
            width: 100%;
            height: auto;
        }
    }

    @media (max-width: 1150px) {
        .ad-search-bar {
            position: static;
        }

        .phone {
            margin-top: 50px !important;
        }

        .business-description {
            padding: 64px 16px 48px;
        }

        .last-ad {
            padding: 64px 16px 48px;
        }

        .site-link {
            padding: 64px 16px 48px;
        }
    }

    @media (max-width: 790px) {

        .business-description,
        .site-link {
            .flex {
                flex-wrap: wrap;
            }
        }
    }
}
</style>